module.exports = __webpack_public_path__ + "static/media/catban2.3fc55e2a.png";